import { Activity, LineChart, ShieldCheck, Users } from "lucide-react";

const TEXTURE =
  "https://images.unsplash.com/photo-1707209856577-eeea3627f8bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwYWJzdHJhY3QlMjB0ZXh0dXJlJTIwYmFja2dyb3VuZHxlbnwwfHx8dGVhbHwxNzg4MzQwMDQ2fDA&ixlib=rb-4.1.0&q=85";

export const GoogleIcon = () => (
  <svg className="h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.8-5.5 3.8-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.9 1.5l2.6-2.6C16.8 3.1 14.6 2.1 12 2.1 6.5 2.1 2.1 6.5 2.1 12S6.5 21.9 12 21.9c5.7 0 9.5-4 9.5-9.7 0-.7-.1-1.2-.2-1.7H12z" />
  </svg>
);

export const AuthLayout = ({ title, subtitle, children }) => (
  <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-background">
    <div className="flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-10">
          <span className="h-10 w-10 rounded-xl bg-primary text-primary-foreground flex items-center justify-center">
            <Activity className="h-5 w-5" />
          </span>
          <span className="font-heading font-semibold text-xl tracking-tight">ABA Clinica</span>
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight">{title}</h1>
        <p className="text-muted-foreground mt-2 mb-8">{subtitle}</p>
        {children}
      </div>
    </div>
    <div className="hidden lg:flex relative overflow-hidden bg-accent">
      <img src={TEXTURE} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/30 to-white/70" />
      <div className="relative z-10 flex flex-col justify-end p-14 gap-8">
        <div>
          <h2 className="font-heading text-3xl font-semibold text-foreground leading-tight">
            Analisi comportamentale applicata,<br />un grafico per ogni azione.
          </h2>
          <p className="text-muted-foreground mt-3 max-w-md">
            Raccogli i dati di sessione per operanti verbali e performance visiva, monitora il criterio di padronanza e documenta i progressi di ogni bambino.
          </p>
        </div>
        <ul className="grid gap-3 text-sm text-foreground/90">
          <li className="flex items-center gap-3"><LineChart className="h-4 w-4 text-primary" /> Grafici ABA con criterio, trend e cambio fase</li>
          <li className="flex items-center gap-3"><Users className="h-4 w-4 text-primary" /> Pazienti condivisi con tutto il team clinico</li>
          <li className="flex items-center gap-3"><ShieldCheck className="h-4 w-4 text-primary" /> Accesso sicuro con email o Google</li>
        </ul>
      </div>
    </div>
  </div>
);

export const startGoogleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
